module.exports = __webpack_public_path__ + "img/Rectangle@2x.78c95f09.png";